import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import { Container } from 'reactstrap';

import ThankYouPageContent from '../../components/checkout/ThankYouPageContent';
import RobotsMeta from '../../components/head/RobotsMeta';
import SEOTitle from '../../components/head/SEOTitle';
import GenericLayout from '../../components/layout/GenericLayout';
import Page from '../../components/layout/Page';
import globalTranslations from '../../i18n/globalTranslations';
import { modelOf } from '../../prop-types';
import ConfigStore from '../../store/ConfigStore';
import TrackingStore from '../../store/TrackingStore';
import CommonPage from '../../types/CommonPage';
import OrderType from '../../types/OrderType';
import TrackingEventType from '../../types/TrackingPageType';

@observer
class ProposalThankYouPage extends Component {
  sendTrackingData = (currentOrder) => {
    const { trackingStore, configStore } = this.props;
    const spotmoreEnabled = configStore.integrations.spotmore.enabled;

    if (
      !spotmoreEnabled ||
      typeof document === 'undefined' ||
      !currentOrder ||
      currentOrder.is_success_seen
    ) {
      return null;
    }

    if (spotmoreEnabled && window.crmtracker) {
      window.crmtracker.sendData();
    }

    trackingStore.setPageView({
      page: TrackingEventType.CHECKOUT_SUCCESS,
      refererUrl: document.referrer,
      visitedUrl: window.location.href,
    });
    trackingStore.postPageView();
  };

  onOrderSuccess = (currentOrder) => {
    !window.isSSR && this.sendTrackingData(currentOrder);
  };

  render() {
    return (
      <Page
        name={CommonPage.CHECKOUT_SUCCESS}
        className="ProposalThankYouPage"
        onDefinedTrackingPage={TrackingEventType.CHECKOUT_SUCCESS}
      >
        <Container className="ProposalThankYouPage__container">
          <GenericLayout
            content={
              <Fragment>
                <SEOTitle
                  title={{ ...globalTranslations.successfulProposalPageTitle }}
                />
                <RobotsMeta noindex />
                <ThankYouPageContent
                  onOrderSuccess={this.onOrderSuccess}
                  orderType={OrderType.PROPOSAL_REQUEST}
                />
              </Fragment>
            }
          />
        </Container>
      </Page>
    );
  }
}

ProposalThankYouPage.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  trackingStore: modelOf(TrackingStore).isRequired,
};

export default inject('configStore', 'trackingStore')(ProposalThankYouPage);
